import { configWithTokenId } from '@api/constructor-api'

const couponListHandler = async(branchUUID) => {
    return await configWithTokenId(async(API) => {
        if(branchUUID != null && branchUUID != 'null')
            return await API.get(`branches/${branchUUID}/coupons`)
        throw 'Not Empty Data'
    })
}

const redeemCodeHandler = async(payload) => {
    return await configWithTokenId(async(API) => {
        return await API.post('/point/redeem', payload)
    })
}

export {
    couponListHandler,
    redeemCodeHandler
}